import styled from 'styled-components';

export const BaserunnersFlowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-size: 100% 100%;
  margin-top: 4px;
`;

export const EditChipWrapper = styled.div`
  position: relative;
`;

export const ThirdRow = styled.div`
  margin-bottom: auto;
  display: flex;
  margin-left: 5%;
  margin-right: 5%;
  justify-content: space-around;
`;
